const isEnteringViewport = (element) => {

    var topOfElement = jQuery(element).offset().top;
    var bottomOfWindow = jQuery(window).scrollTop() + jQuery(window).height();

    return bottomOfWindow > topOfElement;
}

export default isEnteringViewport;